import { render, staticRenderFns } from "./ModalEmbalagens.vue?vue&type=template&id=c24addbe&scoped=true&"
import script from "./ModalEmbalagens.vue?vue&type=script&lang=js&"
export * from "./ModalEmbalagens.vue?vue&type=script&lang=js&"
import style0 from "./ModalEmbalagens.vue?vue&type=style&index=0&id=c24addbe&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c24addbe",
  null
  
)

export default component.exports